import * as React from 'react';
import styled from 'styled-components';

interface IIconProps {
  color?: string;
  iconFlip?: boolean;
  inverse?: boolean;
  weight?: number;
}

const DefaultIcon = styled.i.attrs({ role: 'presentation' })<IIconProps>`
  color: ${(props: { color?: string; inverse?: boolean }): string =>
    props?.inverse
      ? 'var(--color-dark-text)'
      : props.color
      ? `${props.color}`
      : 'var(--color-text)'};
  font-family: 'Material Symbols Outlined';
  font-weight: normal;
  font-style: normal;
  font-variation-settings: 'FILL' 0, 'wght' ${(props: IIconProps): number =>
    props.weight ?? 300}, 'GRAD' 0, 'opsz' 24;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  word-wrap: normal;
  -moz-font-feature-settings: 'liga';
  font-feature-settings: 'liga';
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
  transition-property: transform;
  transition-duration: 0.9s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transform: ${(props: IIconProps): string =>
    props.iconFlip ? 'rotate(180deg)' : 'rotate(0deg)'};
  cursor: pointer;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LargeIcon = styled(DefaultIcon as any)`
  font-size: 130px;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MediumIcon = styled(DefaultIcon as any)`
  font-size: 40px;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ListAvatarIcon = styled(DefaultIcon as any)`
  font-size: 30px;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SmallIcon = styled(DefaultIcon as any)`
  font-size: 24px;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TinyIcon = styled(DefaultIcon as any)`
  font-size: 20px;
`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const XLargeIcon = styled(DefaultIcon as any)`
  font-size: 25rem;
`;

interface IProps {
  color?: string;
  name: string;
  style?: React.CSSProperties;
  onClick?: (e?: React.MouseEvent) => void;
  size?: IconSize;
  iconFlip?: boolean;
  inverse?: boolean;
  title?: string;
  alt?: string;
  weight?: number;
}

export type IconSize =
  | 'x-large'
  | 'large'
  | 'medium'
  | 'small'
  | 'tiny'
  | 'list-avatar';

export const Icon = (props: IProps): React.ReactElement => {
  switch (props.size) {
    case 'x-large':
      return (
        <XLargeIcon
          color={props.color}
          alt={props.alt}
          onClick={props.onClick}
          style={props.style}
          iconFlip={props.iconFlip}
          inverse={props.inverse}
          title={props.title}
          weight={props.weight}
        >
          {props.name}
        </XLargeIcon>
      );
    case 'large':
      return (
        <LargeIcon
          color={props.color}
          alt={props.alt}
          onClick={props.onClick}
          style={props.style}
          iconFlip={props.iconFlip}
          inverse={props.inverse}
          title={props.title}
          weight={props.weight}
        >
          {props.name}
        </LargeIcon>
      );
    case 'medium':
      return (
        <MediumIcon
          color={props.color}
          alt={props.alt}
          onClick={props.onClick}
          style={props.style}
          iconFlip={props.iconFlip}
          inverse={props.inverse}
          title={props.title}
          weight={props.weight}
        >
          {props.name}
        </MediumIcon>
      );
    case 'list-avatar':
      return (
        <ListAvatarIcon
          color={props.color}
          alt={props.alt}
          onClick={props.onClick}
          style={props.style}
          iconFlip={props.iconFlip}
          inverse={props.inverse}
          title={props.title}
          weight={props.weight}
        >
          {props.name}
        </ListAvatarIcon>
      );
    case 'tiny':
      return (
        <TinyIcon
          color={props.color}
          alt={props.alt}
          onClick={props.onClick}
          style={props.style}
          iconFlip={props.iconFlip}
          inverse={props.inverse}
          title={props.title}
          weight={props.weight}
        >
          {props.name}
        </TinyIcon>
      );
    default:
      return (
        <SmallIcon
          color={props.color}
          alt={props.alt}
          onClick={props.onClick}
          style={props.style}
          iconFlip={props.iconFlip}
          inverse={props.inverse}
          title={props.title}
          weight={props.weight}
        >
          {props.name}
        </SmallIcon>
      );
  }
};
